// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#select-JBrowse{margin:30px auto;width:1100px}#select-JBrowse .JBrowse-description{margin:20px auto 20px 0;width:1000px;color:#30336b;text-align:left;font-size:25px}#select-JBrowse .JBrowse_button{background:#e8f2ec;border:none;color:#275015;font-size:16px}#select-JBrowse .JBrowse_button:hover{color:red}", ""]);
// Exports
module.exports = exports;
